module.exports = __webpack_public_path__ + "img/odp.93a4b549.svg";